import React, { useEffect, useRef, useState } from "react"
import "./new-rcf-style.css"
// import "swiper/css"
// import "swiper/css/navigation"
// import "../../Sliders/sliders.scss"
import PlusImage from "../../../asst/Plus-more-pics.svg"
import imgShareUpload from "../../../asst/ImageShareUpload.svg"
import Cancel from "../../../asst/Cancel.svg"
import {
  checkAccess,
  checkAccessed,
  encryptData,
  getImageUrl,
  getThumbnailImageUrl,
  link,
  uploadToS3,
} from "../../../helper"
import ApiManager from "../../../classes/ApiManager"
import { useSearchParams } from "react-router-dom"
import NewTellUsStarter from "./NewTellUsStarted"
import NewRatePopup from "./NewRatePopup"
import ReviewImage from "../../../images/review-popup-image.png"
import NewThatsAll from "./NewThatsAll"
import NewReviewSubSimple from "./NewReviewSubSimple"
import SectionLoader from "./SectionLoader"
import { CrossIcon } from "../../../Svgs/Svg"
import OfferDiscount from "./OfferDiscount"
import NewReviewsComfirm from "./NewReviewConfirm"
import NewEditReviews from "./NewEditReview"
import NewReviewVideoSimple from "./NewReviewVideoSimple"
import RcfHeader from "./RcfHeader"

export default function NewRcf() {
  const apiManager = ApiManager.getInstance()
  const [searchParams, setSearchParams] = useSearchParams()
  apiManager._setXToken(searchParams.get("merchantId"))
  let xToken = searchParams.get("merchantId")
  let storeCurrency = searchParams.get("storeCurrency")
  let offside = searchParams.get("offside")

  localStorage.setItem("subx", xToken)

  const [orderNo, setOrderNo] = useState(searchParams.get("orderNo"))
  let productTitle = searchParams.get("productName")
  let productId = searchParams.get("productId")
  let productImage = searchParams.get("productImage")
  let storeName = searchParams.get("storeName")
  let reviewId = searchParams.get("id")
  let merchantReviewId = searchParams.get("merchantId")
  let edit = searchParams.get("edit")

  const [currentComponentIndex, setCurrentComponentIndex] = useState(0)
  const [error, setError] = useState(true)
  const [attributeValue, setAttribute] = useState([])
  const [requiredAttributes, setRequiredAttributes] = useState(false)
  const [data, setData] = useState({})
  console.log("🚀 ~ NewRcf ~ data:", data)
  const [isTyped, setisTyped] = useState(false)
  const [starCheck, setStarCheck] = useState(false)
  const [starReview, setReviewCheck] = useState(false)
  // New validation states for title and description
  const [titleError, setTitleError] = useState(false)
  const [descriptionError, setDescriptionError] = useState(false)
  const [answer, setAnswer] = useState(3)
  const [showDetail, setShowDetail] = useState(false)
  const [editReviewData, setEditReviewData] = useState({})
  const [deleteFile, setDeleteFile] = useState([])

  const [attributeAnswerValue, setAttributeAnswerValue] = useState(true)
  const [attributeAnswerMultipleValue, setAttributeAnswerMultipleValue] =
    useState(true)
  const [settings, setSettings] = useState({})
  const [collectSettings, setCollectSettings] = useState({})
  const [newDiscount, setNewDiscount] = useState({
    typeOfDiscount: "perc",
    value: "10",
  })
  const [showLoader, setShowLoader] = useState(false)
  console.log("🚀 ~ showLoader:", showLoader)
  const [pageLoader, setPageLoader] = useState(true)
  console.log("🚀 ~ pageLoader:", pageLoader)
  const [showLoaderSub, setShowLoaderSub] = useState(true)
  console.log("🚀 ~ showLoaderSub:", showLoaderSub)
  const [errorAttribute, setErrorAttribute] = useState(false)
  let rcfvalue = searchParams.get("rcf") === "true"

  function getHighestDiscount(discounts) {
    const keys = [
      "discountForTextReview",
      "discountForPhotoReview",
      "discountForVideoReview",
    ]
    const sortedKeys = keys.sort((a, b) => {
      const valueA = parseFloat(discounts?.[a]?.value) || 0 // Safely access properties
      const valueB = parseFloat(discounts?.[b]?.value) || 0
      if (valueA === valueB) {
        return a === "discountForVideoReview" ? -1 : 1
      }
      return valueB - valueA
    })

    const highestDiscount = discounts?.[sortedKeys[0]]
    setNewDiscount(highestDiscount) // Safely call setState
    return { [sortedKeys[0]]: highestDiscount }
  }

  // const [alreadyAdded, setAlreadyAdded] = useState(false)
  const [files, setFiles] = useState([])
  const [codeData, setCodeData] = useState(null)
  const [editReview, setEditReview] = useState(null)
  const [attributes, setAttributes] = useState([])
  // const [displayReviewData, setDisplayReviewData] = useState([])

  const handleContinueClick = () => {
    setCurrentComponentIndex(currentComponentIndex + 1)
    window.scrollTo({ top: 0 })
  }
  const handleBack = () => {
    setCurrentComponentIndex(currentComponentIndex - 1)
    window.scrollTo({ top: 0 })
  }
  // function getQueryString() {
  //   var queryStringKeyValue = window.parent.location.search.replace('?', '').split('&');
  //   var qsJsonObject = {};
  //   if (queryStringKeyValue != '') {
  //     for (let i = 0; i < queryStringKeyValue.length; i++) {
  //       qsJsonObject[queryStringKeyValue[i].split('=')[0]] = queryStringKeyValue[i].split('=')[1];
  //     }
  //   }
  //   return qsJsonObject;
  // }

  // const [locationName, setLocationName] = useState({
  //   name: "",
  //   latitude: "",
  //   longitude: "",
  // })
  const getCurrencySymbol = (currencyCode) => {
    try {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currencyCode,
      })
      const parts = formatter.formatToParts(0)
      const currencySymbol = parts.find(
        (part) => part.type === "currency"
      ).value
      return currencySymbol
    } catch (error) {
      console.log("Error getting currency symbol:", error)
      return "USD"
    }
  }
  const [photoRcf, setPhotoRcf] = useState(false)
  const [isDisable, setIsDisable] = useState(false)
  const [ordersData, setOrdersData] = useState({})

  const togglePhotoReview = () => {
    setPhotoRcf(!true)
  }

  let photoReviews = collectSettings?.photoReviews?.show ?? true
  let videoReviews = collectSettings?.videoReviews?.show ?? true
  const [fName, setFName] = useState(ordersData?.[0]?.customerName ?? "")
  const [lName, setLName] = useState("")
  const [email, setEmail] = useState("")
  const [isTyped1, setIsTyped1] = useState(ordersData.length > 0 ? true : false)
  const [isTyped2, setIsTyped2] = useState(ordersData.length > 0 ? true : false)
  const [isTyped3, setIsTyped3] = useState(ordersData.length > 0 ? true : false)
  const [addPlan, setAddPlan] = useState("")
  useEffect(() => {
    if (edit) {
      const editReview = async () => {
        setShowLoader(true)
        try {
          const query = `${link}getReviewById?${reviewId ? `id=${reviewId}` : ""
            }${reviewId && merchantReviewId ? "&" : ""}${merchantReviewId ? `merchantId=${merchantReviewId}` : ""
            }`

          const response = await fetch(query, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })

          const res = await response.json()
          setOrderNo(res?.result?.orderNo ?? 123)
          setOrdersData([
            {
              products: [
                {
                  title: res?.result?.productName,
                  id: res?.result?.productId,
                  image: res?.result?.productImage,
                },
              ],
              customerName: res?.result?.reviewerName,
              customerEmail: res?.result?.reviewerEmail,
            },
          ])
          setData({
            review: res?.result?.reviewRating,
            title: res?.result?.reviewDetails,
            description: res?.result?.reviewDescription,
            attributes: res?.result?.attributes,
            reviewerEmail: res?.result?.reviewerEmail,
            orderNo: res?.result?.orderNo,
            productName: res?.result?.productName,
            mediaType: Array.isArray(res?.result?.images)
              ? res?.result?.images.filter((data) => data?.mediaType)
              : [],
          })
          if (res?.result?.images?.length > 0) {
            setFiles(
              res?.result?.images.map((image) => ({
                name: image?.mediaUrl,
                mediaType: image?.mediaType,
                _id: image?._id,
              }))
            )
          }
          setAttributes(res?.result?.attributes)
          let answers = {}
          res?.result?.attributes?.map((item) => {
            answers[item?.widgetType] = item?.selectedAnswer?.value
          })
          setReviewCheck(true)
          setAnswer(answers)
          setEditReviewData(res?.result)
          setShowLoader(false)
        } catch (error) {
          console.error("Error fetching data:", error)
        }
      }

      editReview()
    }
  }, [reviewId, merchantReviewId])

  useEffect(() => {
  }, [data, ordersData, isTyped1])

  useEffect(() => {
    if (!edit) {
      apiManager
        .get("getGeneralSettings", null)
        .then((responseGeneral) => {
          if (orderNo) {
            apiManager
              .get("getOrders", { orderNo: orderNo })
              .then((response) => {
                let data = response.result?.docs?.[0]?.products[0]?.status
                  ? response.result?.docs?.[0]?.products?.filter(
                    (item) => item.status === 1
                  )
                  : response.result?.docs?.[0]?.products
                if (response.result?.docs?.[0]) {
                  response.result.docs[0].products = data
                }
                let list =
                  responseGeneral?.result?.productBlockList?.map((item) =>
                    item.id?.includes("gid://shopify/Product/")
                      ? item.id.split("gid://shopify/Product/")[1]
                      : item.id
                  ) || []
                const updatedDocs = response.result.docs.map((doc, index) => {
                  if (index === 0) {
                    return {
                      ...doc,
                      products: doc.products.filter(
                        (product) => !list.includes(product.product_id)
                      ),
                    }
                  }
                  return doc
                })
                setOrdersData(updatedDocs)
              })
              .catch((error) => {
                console.error("Error:In getOrders", error)
              })
          } else {
            setOrdersData([
              {
                products: [
                  {
                    title: productTitle,
                    id: productId,
                    image: productImage,
                  },
                ],
              },
            ])
          }
        })
        .catch((error) => {
          console.error("Error:In getBrandSettings", error)
        })
    }
  }, [])

  const submit = async (userData) => {
    setShowLoader(true)
    let body = {
      productID:
        ordersData[0]?.products[orderProductIndex - 1]?.product_id ??
        searchParams.get("productId"),
      merchantId: searchParams.get("merchantId"),

      productImage:
        ordersData[0]?.products[orderProductIndex - 1]?.image ??
        searchParams.get("productImage"),
      reviewRating: data?.review,
      reviewTitle: data?.title ?? "",
      reviewDescription: data?.description,
      productName:
        ordersData[0]?.products[orderProductIndex - 1]?.title ??
        searchParams.get("productName"),
      title:
        ordersData[0]?.products[orderProductIndex - 1]?.title ??
        searchParams.get("productName"),
      reviewNo: orderProductIndex,
      mediaType: 3,
      contentType: 2,
      reviewerName:
        ordersData?.[0]?.customerName ??
        userData?.reviewerName ??
        data?.reviewerName,
      reviewerEmail:
        ordersData?.[0]?.customerEmail ??
        userData?.reviewerEmail ??
        data?.reviewerEmail,
      attributes: data?.attributes,
      images: [],
      isAuthorized: orderNo ? true : false,
      orderNo: orderNo,
      source: orderNo ? "Email" : "On-site form",
      isEdit: false,
    }
    if (!body.mediaUrl) {
    }
    console.log("dataeqrw", { data: encryptData(body) })
    setFiles([])

    try {
      // Create a new FormData object
      const formData = new FormData()
      if (files.length > 0) {
        body.contentType = 1
        // Append files to the FormData object
        files.forEach((file, index) => {
          formData.append(`files`, file)
        })
      }

      formData.append("data", encryptData(body))

      fetch(link + "addVReview", {
        method: "POST",
        headers: {
          // "Content-Type": "application/json",
          "x-token": searchParams.get("id"),
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((res) => {
          setCodeData(res?.review)
          setShowLoader(false)
          setSettings(res?.review)
          setShowDetail(true)
          if (res?.message === 2003) {
            handleContinueClick()
            setData({})
            setStarCheck(false)
          } else {
            alert("You cannot add multiple reviews")
          }

          if (orderProductIndex == ordersData?.[0]?.products.length)
            setShowLoaderSub(false)
        })

        .catch((error) => {
          setShowLoader(false)
          console.error("Error fetching data:", error)
        })
    } catch (error) {
      setShowLoader(false)
      console.error("Error fetching data:2", error)
    }
  }

  const submitEditReview = async (userData) => {
    setShowLoader(true)
    let body = {
      id: searchParams.get("id"),
      productID:
        ordersData[0]?.products[orderProductIndex - 1]?.id ??
        searchParams.get("productId"),
      merchantId: searchParams.get("merchantId"),

      productImage:
        ordersData[0]?.products[orderProductIndex - 1]?.image ??
        searchParams.get("productImage"),
      reviewRating: data?.review || editReviewData?.reviewRating,
      reviewDetails: data?.title || editReviewData?.reviewDetails,
      reviewDescription: data?.description || editReviewData?.reviewDescription,
      productName:
        ordersData[0]?.products[orderProductIndex - 1]?.title ||
        searchParams.get("productName"),
      reviewerName:
        ordersData?.[0]?.customerName ??
        userData?.reviewerName ??
        data?.reviewerName,
      reviewerEmail:
        ordersData?.[0]?.customerEmail ??
        userData?.reviewerEmail ??
        data?.reviewerEmail,
      attributes: data?.attributes || editReviewData?.attributes,
      images: editReviewData?.images || [],
      isEdit: true,
      deleteFile: deleteFile,
    }
    if (!body.mediaUrl) {
    }
    console.log("dataeqrw", { data: encryptData(body) })
    setFiles([])

    try {
      const formData = new FormData()
      if (files.length > 0) {
        body.contentType = 1
        files.forEach((file, index) => {
          formData.append(`files`, file)
        })
      }
      formData.append("data", encryptData(body))
      apiManager
        .postFormData("updateReview", formData)
        .then((res) => {
          setEditReview(res?.updatedReviews?.[0])
          setSettings(res?.updatedReviews?.[0])
          setShowLoader(false)
          setShowDetail(true)
          // if (res?.message === 2003) {
          //   setEditReview({})
          // }
          if (orderProductIndex == ordersData?.[0]?.products.length)
            setShowLoaderSub(false)
        })
        .catch((error) => {
          setShowLoader(false)
          console.error("Error fetching data:", error)
        })
    } catch (error) {
      setShowLoader(false)
      console.error("Error fetching data:2", error)
    }
  }

  const sliderRef = useRef(null)
  const [sliderValue, setSliderValue] = useState(null)
  React.useEffect(() => {
    getPlan()
    try {
      let body = {
        productID: searchParams.get("productId"),
        merchantId: searchParams.get("merchantId"),
        productImage: searchParams.get("productImage"),
        item: {
          image: searchParams.get("productImage"),
          title: searchParams.get("productName"),
        },
      }
      setData({ ...body, attributes: [] })
      apiManager
        .get("getCollectReview", { merchantId: body?.merchantId })

        .then((res) => {
          setSettings(res?.result?.newReviewForm)
          if (res?.result?.discounts) {
            getHighestDiscount(res?.result?.discounts)
          }
          setCollectSettings(res?.result)
        })
        .catch((error) => {
          console.error("Error fetching data:", error)
        })
      if (!edit) getAttributes()
      else setPageLoader(false)

      setError(false)
    } catch (error) {
      setError(true)
    }
  }, [])

  const [brandSettingsData, setBrandSettingsData] = useState({})
  useEffect(() => {
    apiManager
      .get("getBrandSettings", null)
      .then((response) => {
        setBrandSettingsData(response.result)
      })
      .catch((error) => {
        console.error("Error:In getBrandSettings", error)
      })
  }, [])

  const getPlan = async () => {
    apiManager
      .get("getPlan")
      .then((res) => {
        setAddPlan(res?.result)
        apiManager?._setSubscription(res?.result)
      })
      .catch((error) => {
        console.error("Error fetching data:", error)
      })
  }

  const getAttributes = async () => {
    apiManager
      .get("getAttributes")
      .then((res) => {
        setAttributes(res?.result)
        setPageLoader(false)
      })
      .catch((error) => {
        console.error("Error fetching data:", error)
      })
  }

  useEffect(() => {
    // console.log(
    //   data?.review === undefined ||
    //     data?.description == "" ||
    //     data?.description === undefined,
    //   data?.description == "" || data?.description === undefined,
    //   "....thisIsDataClg"
    // )
    if (
      data?.review === undefined
      // ||
      // data?.description == "" ||
      // data?.description === undefined
      // ||
      // data?.attributes.length === 0
    ) {
      setIsDisable(true)
    } else {
      setIsDisable(false)
    }
  }, [data])

  const [orderProductIndex, setOrderProductIndex] = useState(1)
  const [submitReview, setSubmitReview] = useState(false)

  const [titleValue, setTitleValue] = useState("")
  const [desValue, setDesValue] = useState("")

  const isOnSite = searchParams.get("isOnsite") === "true"
  console.log(isOnSite, "===>isOnSite")
  return (
    <div className="new-rcf-container"
      style={{
        backgroundColor: isOnSite ? "rgb(0 0 0 / 60%)" : "lightgray",
        minHeight: "100vh",
      }}>
      <div className="new-rcf-container-inner">
        <RcfHeader
          brandSettingsData={brandSettingsData}
          getImageUrl={getImageUrl}
          storeName={storeName}
          isOnSite={isOnSite}
        />

        {pageLoader ? (
          <SectionLoader />
        ) : showLoaderSub ? (
          showLoader ? (
            <SectionLoader />
          ) : (
            <>
              <div>
                <div
                  className="rcf-product-div-heading"
                  style={{
                    color: settings?.fontColor ?? "#000",
                    backgroundColor: settings?.backgroundColor ?? "#fff",
                    paddingBottom: offside === "true" ? "30px" : "30px",
                  }}
                >
                  <div className="slider-wrapper-rcf">
                    <>
                      <div>
                        <div
                          className="slide-content c-pointer"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "25px",
                          }}
                        >


                          {/* <hr style={{ margin: "0px" }} /> */}
                          <NewRatePopup
                            onTitleChange={(e) => {
                              setData({ ...data, title: e.target.value })
                            }}
                            onReviewSelect={(rating) => {
                              setData({ ...data, review: rating })
                            }}
                            data={data}
                            settings={settings}
                            brandSettingsData={brandSettingsData}
                            collectSettings={collectSettings}
                            setStarCheck={setStarCheck}
                            orderProductIndex={orderProductIndex}
                            ordersData={ordersData}
                            starCheck={starCheck}
                            xToken={xToken}
                            newDiscount={newDiscount}
                            storeCurrency={storeCurrency}
                            getCurrencySymbol={getCurrencySymbol}
                            checkAccessed={checkAccessed}
                            isOnSite={isOnSite}
                          // item={item}
                          />



                          <NewTellUsStarter
                            errorAttribute={errorAttribute}
                            setErrorAttribute={setErrorAttribute}
                            requiredAttributes={requiredAttributes}
                            setRequiredAttributes={setRequiredAttributes}
                            attributeValue={attributeValue}
                            setAttribute={setAttribute}
                            settings={settings}
                            sliderRef={sliderRef}
                            sliderValue={sliderValue}
                            setSliderValue={setSliderValue}
                            setisTyped={setisTyped}
                            answer={answer}
                            setAnswer={setAnswer}
                            ordersData={ordersData}
                            orderProductIndex={orderProductIndex}
                            data={data}
                            isEdit={edit}
                            setData={setData}
                            setFiles={setFiles}
                            // ProductIndex={ProductIndex}
                            attributes={attributes}
                            onDescriptionChange={(e) => {
                              setData({
                                ...data,
                                description: e.target.value,
                              })
                              setDesValue(e.target.value)
                            }}
                            onTitleChange={(e) => {
                              setData({ ...data, title: e.target.value })
                              setTitleValue(e.target.value)
                            }}
                            onAttributeSelect={(attribute) => {
                              setData({ ...data, attributes: attribute })
                            }}
                            titleValue={titleValue}
                            // New validation props
                            titleError={titleError}
                            setTitleError={setTitleError}
                            descriptionError={descriptionError}
                            setDescriptionError={setDescriptionError}
                            desValue={desValue}
                            setReviewCheck={setReviewCheck}
                            starReview={starReview}
                            setAttributeAnswerValue={setAttributeAnswerValue}
                            setAttributeAnswerMultipleValue={
                              setAttributeAnswerMultipleValue
                            }
                            files={files}

                            collectSettings={collectSettings}
                            newDiscount={newDiscount}
                            getCurrencySymbol={getCurrencySymbol}
                            storeCurrency={storeCurrency}
                            PlusImage={PlusImage}
                            edit={edit}
                            setDeleteFile={setDeleteFile}
                            isOnSite={isOnSite}

                          />


                        </div>
                      </div>
                    </>
                  </div>

                  {/* <Button onClick={() => swiper.slideNext()}>Hi there??</Button> */}

                  <NewThatsAll
                    isOnSite={isOnSite}
                    errorAttribute={errorAttribute}
                    setRequiredAttributes={setRequiredAttributes}
                    isTyped={isTyped}
                    edit={edit}
                    onContinueClick={submit}
                    onEditReviewClick={submitEditReview}
                    handleBack={handleBack}
                    attributes={attributes}
                    ordersData={ordersData}
                    orderProductIndex={orderProductIndex}
                    isDisable={isDisable}
                    settings={settings}
                    fName={fName}
                    setFName={setFName}
                    lName={lName}
                    setLName={setLName}
                    email={email}
                    setEmail={setEmail}
                    isTyped1={
                      orderNo
                        ? ordersData?.[0]?.customerName?.split(" ")?.[0]
                        : isTyped1
                    }
                    isTyped2={
                      orderNo
                        ? ordersData?.[0]?.customerName?.split(" ")?.[1]
                        : isTyped2
                    }
                    isTyped3={orderNo ? ordersData?.[0]?.customerEmail : isTyped3}
                    setIsTyped1={setIsTyped1}
                    setIsTyped2={setIsTyped2}
                    setIsTyped3={setIsTyped3}
                    data={data}
                    setAnswer={setAnswer}
                    starCheck={starCheck}
                    showDetail={showDetail}
                    starReview={starReview}
                    setOrderProductIndex={setOrderProductIndex}
                    files={files}
                    orderNo={orderNo}
                    setStarCheck={setStarCheck}
                    // New validation props
                    titleError={titleError}
                    setTitleError={setTitleError}
                    descriptionError={descriptionError}
                    setDescriptionError={setDescriptionError}
                    collectSettings={collectSettings}
                  />
                </div>
              </div>
            </>
          )
        )
          : codeData?.isEdit === false &&
            codeData?.source === "On-site form" &&
            codeData?.onSiteVerified === false ? (
            <NewReviewsComfirm codeData={codeData} />
          ) : codeData?.code && codeData?.isEdit === false && checkAccessed("discountCode") === true ? (
            <OfferDiscount
              settings={settings}
              setOrderProductIndex={setOrderProductIndex}
              discount={codeData}
            />
          ) : editReview?.isEdit === true ? (
            <NewEditReviews
              editReview={editReview}
              setOrderProductIndex={setOrderProductIndex}
            />
          ) : codeData?.images?.some(image => image?.mediaType === 1) && codeData?.merchantId === "adxee-gear.myshopify.com" ? (
            <NewReviewVideoSimple
              settings={settings} />
          ) : (
            <NewReviewSubSimple
              brandSettingsData={brandSettingsData}
              settings={settings}
              setOrderProductIndex={setOrderProductIndex}
            />
          )
        }
      </div>
    </div>
  )
}
